import { useState, useEffect } from 'react'
import axios from 'axios'
import { API_URL, Currency, FormatNumber, config, UserCode, API_IMAGES } from '../components/Include';
import { Alerts } from '../components/notify';
import { getBritishDate } from '../components/GlobalFunction';
import { useSelector } from 'react-redux'
import './printout.css';
import { useParams } from 'react-router-dom';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
const Printout = () => {
  const [invoice, setInvoice] = useState({
    
    skill:[] as any,
    schedule:[] as any,
    
  });
  const [loading, setLoading] = useState(true);
  const [printLoading, setPrintLoading] = useState(false);
  const [materialLoading, setMaterialLoading] = useState(false);

  const student = useSelector((state:any) => state.rootReducer.student);
  const course_code = useParams().code;

  const FetchSchedule = () => {
    setLoading(true);
    const url = API_URL + '/student/training/' + UserCode+'/'+course_code+'/'+student?.study_mode;
    
    axios.get(url, config)
      .then((response:any) => {
        if (response.data.status === 200) {
          setInvoice({
            skill:response.data.data,
            schedule:response.data.training,
          });
        }
      })
      .catch((error) => {
        Alerts('danger', error.message, 'Something went wrong!');
      })
      .finally(() => {
        setLoading(false);
      });
  };



  // Generate a QR code URL for verification
  const generateQRCode = (data: string) => {
    const qrData = encodeURIComponent(`${data}`);
    return `https://api.qrserver.com/v1/create-qr-code/?size=150x150&data=${qrData}`;
  };

  // Format date for display
  const formatDate = (dateString: string) => {
    return getBritishDate(dateString);
  };

  // Handle course material download
  const handleDownloadMaterial = () => {
    setMaterialLoading(true);
    const fileUrl = API_IMAGES+'/website/facilitator/ENTC221_Complete_Final.pdf';

    const link = document.createElement('a');
    link.href = fileUrl;
    link.download = 'ENTC221_Complete_Final.pdf';
    link.target = '_blank';
    link.rel = 'noopener';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    setMaterialLoading(false);
  };

  // Handle print action
  const handlePrint = () => {
    if (!invoice.skill || invoice.skill.length === 0) {
      Alerts('warning', 'No registration data to print', 'Warning');
      return;
    }

    setPrintLoading(true);
    const list = invoice.skill[0];
    const doc = new jsPDF();
    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();

    // Add logo
    const logo = new Image();
    logo.src = '/images/edc.png';
    logo.onload = () => {
      doc.addImage(logo, 'PNG', 15, 10, 40, 25);
      generatePDFContent();
    };

    logo.onerror = () => {
      generatePDFContent();
    };

    const generatePDFContent = () => {
      // Header
      doc.setFontSize(16);
      doc.setFont('helvetica', 'bold');
      doc.text('Entrepreneurship Development Center', pageWidth / 2, 20, { align: 'center' });
      
      doc.setFontSize(14);
      doc.text('Nasarawa State University, Keffi', pageWidth / 2, 27, { align: 'center' });
      
      doc.setFontSize(12);
      doc.setFont('helvetica', 'normal');
      doc.text('Office of the Director', pageWidth / 2, 33, { align: 'center' });

      // Title
      let yPos = 45;
      doc.setFontSize(14);
      doc.setFont('helvetica', 'bold');
      const title = `${list.session} ${list.course_code} ${list.course_title}`;
      doc.text(title, pageWidth / 2, yPos, { align: 'center' });

    

      // Amount Paid
      yPos += 15;
      doc.setFontSize(18);
      doc.setFont('helvetica', 'bold');
      doc.setTextColor(40, 167, 69);
      doc.text( 'Amount:' + FormatNumber(list.amount_paid), pageWidth / 2, yPos, { align: 'center' });
      doc.setTextColor(0, 0, 0);

      // Find training period
      const faculty = String(list.faculty || '').trim().toLowerCase();
      const match = invoice?.schedule?.find((sched: any) => {
        const raw = sched?.department;
        if (raw == null) return false;
        if (Array.isArray(raw)) {
          return raw.map((v: any) => String(v).trim().toLowerCase()).includes(faculty);
        }
        const depStr = String(raw).trim();
        const depNorm = depStr.toLowerCase();
        if (depNorm === faculty) return true;
        if (depStr.startsWith('[')) {
          try {
            const parsed = JSON.parse(depStr);
            if (Array.isArray(parsed)) {
              return parsed.map((v: any) => String(v).trim().toLowerCase()).includes(faculty);
            }
          } catch (e) {
            return false;
          }
        }
        return depStr.split(',').map((v: string) => v.trim().toLowerCase()).includes(faculty);
      });
      const trainingPeriod = match ? `${match.batch} (${match.start_date} to ${match.end_date})` : 'N/A';

      // Details Table
      yPos += 10;
      const tableData = [
        ['Registration Date', formatDate(list.date_paid)],
        ['Payment Reference', list.payment_ref],
        ['Student', `${list.matric_no} - ${list.full_name}`],
        ['Skill', list.title],
        ['Training Period', trainingPeriod],
        ['Program', list.department],
        ['Faculty', list.faculty]
      ];

      autoTable(doc, {
        startY: yPos,
        body: tableData,
        theme: 'grid',
        styles: {
          fontSize: 10,
          cellPadding: 5
        },
        columnStyles: {
          0: { fontStyle: 'bold', cellWidth: 60 },
          1: { cellWidth: 120 }
        }
      });

      // QR Code
      const finalY = (doc as any).lastAutoTable.finalY || yPos;
      yPos = finalY + 15;
      
      const qrImage = new Image();
      qrImage.crossOrigin = 'anonymous';
      qrImage.src = generateQRCode(list.matric_no);
      
      qrImage.onload = () => {
        doc.addImage(qrImage, 'PNG', pageWidth / 2 - 20, yPos, 40, 40);
        doc.setFontSize(9);
        doc.text('Scan to mark attendance', pageWidth / 2, yPos + 45, { align: 'center' });
        finalizePDF();
      };

      qrImage.onerror = () => {
        doc.setFontSize(9);
        doc.text('QR Code: ' + list.matric_no, pageWidth / 2, yPos, { align: 'center' });
        finalizePDF();
      };

      const finalizePDF = () => {
        // Verification Status
        yPos += 55;
        doc.setFontSize(10);
        doc.setTextColor(40, 167, 69);
        doc.text('✓ Payment verified and confirmed', pageWidth / 2, yPos, { align: 'center' });
        doc.setTextColor(0, 0, 0);

        // Footer
        yPos += 10;
        doc.setFontSize(9);
        doc.setFont('helvetica', 'normal');
        const footerText1 = 'This registration slip serves as proof of payment and skill selection.';
        const footerText2 = 'Please keep it safe and present it when required.';
        const footerText3 = 'Note: Training schedule and additional information will be provided at the center.';
        
        doc.text(footerText1, pageWidth / 2, yPos, { align: 'center' });
        doc.text(footerText2, pageWidth / 2, yPos + 5, { align: 'center' });
        doc.setFont('helvetica', 'bold');
        doc.text(footerText3, pageWidth / 2, yPos + 12, { align: 'center' });

        // Generated timestamp
        doc.setFontSize(8);
        doc.setFont('helvetica', 'normal');
        doc.setTextColor(128, 128, 128);
        doc.text(`Generated on: ${new Date().toLocaleString()}`, pageWidth / 2, pageHeight - 10, { align: 'center' });

        // Save PDF
        doc.save(`Registration_Slip_${list.matric_no}_${list.course_code}.pdf`);
        setPrintLoading(false);
      };
    };
  };
  


  useEffect(() => {
    FetchSchedule();
  }, [student]);


  return (
    <>
      {loading ? (
        <div className='overlay'>
          <img src="/images/loader.svg" alt="loader" />
        </div>
      ) : (
        invoice && invoice.skill.map((list: any, id: number) => {
          const trainingPeriod = (() => {
            const faculty = String(list.faculty || '').trim().toLowerCase();
            const match = invoice?.schedule?.find((sched: any) => {
              const raw = sched?.department;

              if (raw == null) return false;

              if (Array.isArray(raw)) {
                return raw.map((v: any) => String(v).trim().toLowerCase()).includes(faculty);
              }

              const depStr = String(raw).trim();
              const depNorm = depStr.toLowerCase();

              if (depNorm === faculty) return true;

              if (depStr.startsWith('[')) {
                try {
                  const parsed = JSON.parse(depStr);
                  if (Array.isArray(parsed)) {
                    return parsed.map((v: any) => String(v).trim().toLowerCase()).includes(faculty);
                  }
                } catch (e) {
                  return false;
                }
              }

              return depStr
                .split(',')
                .map((v: string) => v.trim().toLowerCase())
                .includes(faculty);
            });
            return match ? `${match.batch} (${match.start_date} to ${match.end_date})` : 'Not Assigned';
          })();

          return (
          <div key={id}>
            {/* Success Alert */}
          

            {/* Printout Container */}
            <div className="printout-container">
              {/* Paid Badge */}
            
              {/* Printout Content */}
              <div className="printout-content">
                {/* Logo and Institution */}
                <div className="printout-logo">
                  <img src="/images/edc.png" alt="EDC Logo" className="img-fluid" />
                  <h4>Entrepreneurship Development Center</h4>
                  <h4>Nasarawa State University, Keffi</h4>
                  <h5>Office of the Director</h5>
                </div>

                {/* Registration Title */}
                <h3 className="printout-title">{list.session+' ' + list.course_code+' '+list.course_title}</h3>

                {/* Registration Details */}
                <div className="printout-details">
                  {/* Amount Paid */}
                  <div className="printout-amount">
                    <small>Amount Paid</small>
                    {Currency + FormatNumber(list.amount_paid)}
                  </div>

                  {/* Details Table */}
                  <div className="printout-table-container">
                    <table className="printout-table">
                      <tbody>
                        <tr>
                          <td className="table-label">Registration Date</td>
                          <td className="table-value">{formatDate(list.date_paid)}</td>
                        </tr>
                        <tr>
                          <td className="table-label">Payment Reference</td>
                          <td className="table-value">{list.payment_ref}</td>
                        </tr>
                        <tr>
                          <td className="table-label">Matric Number</td>
                          <td className="table-value">{list.matric_no}</td>
                        </tr>
                        <tr>
                          <td className="table-label">Student Name</td>
                          <td className="table-value">{list.full_name}</td>
                        </tr>
                        <tr>
                          <td className="table-label">Skill Selected</td>
                          <td className="table-value">{list.title}</td>
                        </tr>
                        <tr>
                          <td className="table-label">Training Period</td>
                          <td className="table-value">{trainingPeriod}</td>
                        </tr>
                        <tr>
                          <td className="table-label">Program</td>
                          <td className="table-value">{list.department}</td>
                        </tr>
                        <tr>
                          <td className="table-label">Faculty</td>
                          <td className="table-value">{list.faculty}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                {/* QR Code for Verification */}
                <div className="printout-qr">
                  <img src={generateQRCode(list.matric_no)} alt="Verification QR Code" />
                  <p>Scan to mark attendance</p>
                </div>

                {/* Verification Status */}
                <div className="printout-verification">
                  <i className="fa fa-check-circle"></i>
                  <p>Payment verified and confirmed</p>
                </div>

                {/* Footer */}
                <div className="printout-footer">
                  <p>This registration slip serves as proof of payment and skill selection. Please keep it safe and present it when required.</p>
                  <p><strong>Note:</strong> Training schedule and additional information will be provided at the center.</p>
                  
                  {/* Action Buttons */}
                  <div className="printout-actions no-print">
                    <button 
                      type="button" 
                      onClick={handlePrint} 
                      className="printout-btn printout-btn-print"
                      disabled={printLoading}
                    >
                      {printLoading ? (
                        <>
                          <i className="fa fa-spinner fa-spin"></i> Generating PDF...
                        </>
                      ) : (
                        <>
                          <i className="fa fa-print"></i> Download Registration Slip
                        </>
                      )}
                    </button>
                    <button
                      type="button"
                      onClick={handleDownloadMaterial}
                      className="printout-btn printout-btn-download"
                      disabled={materialLoading}
                    >
                      {materialLoading ? (
                        <>
                          <i className="fa fa-spinner fa-spin"></i> Downloading...
                        </>
                      ) : (
                        <>
                          <i className="fa fa-download"></i> Download Course Material
                        </>
                      )}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          );
        })
      )}

      {invoice.skill.length === 0 && (
        <div className="printout-alert no-print mt-5">
          <i className="fa fa-info"></i>
          <p>No record found, please try again.</p>
        </div>
      )}
    </>
  );
}

export default Printout